var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-modal-product-gallery"},[_c('SfModal',{attrs:{"visible":_vm.isVisible},on:{"close":_vm.closeModal}},[_c('div',{staticClass:"m-modal-product-gallery__content"},[_c('SfGallery',{ref:"gallery",attrs:{"images":_vm.gallery,"current":_vm.activeIndex + 1,"slider-options":{
          animationDuration: 250,
          rewindDuration: 250,
          autoplay: false,
          rewind: false,
          gap: 0,
        }},on:{"click":_vm.onGalleryChange}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }